import { useState } from 'react'
import Device from 'Device'
import { BluePanel, OrangePanel, GreyPanel, PurplePanel, RedPanel, GreenPanel } from './Panels'



export default function BlockDiagram() {
	const [openSection, setOpenSection] = useState("")

	const areaClicked = (color) => {
		setOpenSection(color)
	}

	const onOffCanvasHide = () => {
		setOpenSection("")
	}

	return (
		<>
			<Device className="container d-flex" style={{height : 'fit-content'}} clickEvent={areaClicked} />
			<BluePanel handle={openSection} onHide={onOffCanvasHide} />
			<OrangePanel handle={openSection} onHide={onOffCanvasHide} />
			<GreenPanel handle={openSection} onHide={onOffCanvasHide} />
			<PurplePanel handle={openSection} onHide={onOffCanvasHide} />
			<GreyPanel handle={openSection} onHide={onOffCanvasHide} />
			<RedPanel handle={openSection} onHide={onOffCanvasHide} />
		</>
	)
}
